import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { WeekHours } from "../../models/agreement.model";
import { HrRepository } from "../../repositories/hr.repository";

export interface GetWeekHoursUseCaseParams {
  startDate: string;
  endDate: string;
  pracId: number;
  discId: number;
  professionalFigureId?: string;
  geoId?: string;
  resId?: number;
}

export class GetWeekHoursUseCase
  implements UseCase<GetWeekHoursUseCaseParams, WeekHours[]>
{
  constructor(private repo: HrRepository) {}

  execute(param: GetWeekHoursUseCaseParams): Observable<WeekHours[]> {
    if (!!param.resId) {
      return this.repo.getWeekHoursByPracDiscFPGeoRes(
        param.startDate,
        param.endDate,
        param.pracId ?? -1,
        param.discId,
        param.professionalFigureId!,
        param.geoId!,
        param.resId,
      );
    } else if (!!param.professionalFigureId && !!param.geoId) {
      return this.repo.getWeekHoursByPracDiscFPGeo(
        param.startDate,
        param.endDate,
        param.pracId ?? -1,
        param.discId,
        param.professionalFigureId,
        param.geoId,
      );
    } else {
      return this.repo.getWeekHoursByPracDisc(
        param.startDate,
        param.endDate,
        param.pracId ?? -1,
        param.discId,
      );
    }
  }
}

const getWeekHoursUseCaseFactory = (repo: HrRepository) =>
  new GetWeekHoursUseCase(repo);

export const getWeekHoursUseCaseProvider: Provider = {
  provide: GetWeekHoursUseCase,
  useFactory: getWeekHoursUseCaseFactory,
  deps: [HrRepository],
};
